// ExcelExport.js;

import React from 'react';
import xlsx from 'json-as-xlsx';
import { Button, Text } from 'grommet';
import { getLabelByIndex } from "../Utils/RBGUtils";

const ExcelExport = (props) => {
    // Get the current date and format it as YYYY-MM-DD
    const getFormattedDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Define settings for the Excel file
    let settings = {
        fileName: `${props.name}_${getFormattedDate()}`, // Name of the resulting spreadsheet with date
        extraLength: 3, // A bigger number means that columns will be wider
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
    };

    // Define a callback function that will be called when download is complete
    let callback = function (sheet) {
        console.log("Download complete:", sheet);
    };

    // Function to process data and prepare it for export
    const processDataForExcel = () => {
        if (props.data.length === 0) return { columns: [], content: [] };

        // Function to convert CamelCase to space-separated words
        const camelCaseToSpaces = (str) => {
            return str.replace(/([a-z])([A-Z])/g, '$1 $2');
        };

        // Prepare columns based on the keys from the first item of the data
        const columns = Object.keys(props.data[0])
        .filter(key => !props.excludedKeys.includes(key))
        .map(key => ({
            label: camelCaseToSpaces(key),
            value: key
        }));

        // Prepare content for each row in the data
        const content = props.data.map(item => {
            let row = {};
            // Assuming each item is an object with key-value pairs
            Object.keys(item).forEach(key => {
                if (!props.excludedKeys.includes(key)) {
                    
                    // Add '%' if the key is 'EvaluationProgress'
                    let value = (key === 'EvaluationProgress' && item[key] !== "") ? `${item[key]}%` : (item[key] !== null ? item[key] : "");
                    
                    // Remove leading commas
                    value = value.toString().replace(/^,+/, '');

                    if (props.keysToProcessWithLabel.includes(key)) {
                        value = getLabelByIndex(key, item[key]);
                    }
                    row[key] = value;
                }
            });
            return row;
        });

        return { columns, content };
    };

    // Handler for the button click to download the Excel file
    const downloadXlsxClickHandler = () => {
        const { columns, content } = processDataForExcel();

        const data = [
            {
                sheet: props.name,
                columns,
                content,
            },
        ];

        xlsx(data, settings, callback); // Will download the excel file
    };

    return (
        <Button
            style={{ width: "170px", margin: "0 auto" }}
            primary
            label={
                <Text color="white">
                    <strong>Export to Excel</strong>
                </Text>
            }
            onClick={downloadXlsxClickHandler}
        />
    );
};

export default ExcelExport;

